import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
const state = {
  bindPhoneStatus: 'NO_BIND', //NO_BIND, TO_BIND, BIND_SUCCESS, BIND_FAILED
  checkKey: '',
  toUrl: '/explore',
  SMSCodeVisible: false,
  mobileReal: '13999999999',
  mobileShow: '139****9999',
  imageCodeURL: 'about:blank',
  imageCodeToken: '',
  captchaInfo: '',
  imageCodeVisible: false
}
const mutations = {
  showImageCode (state) {
    state.imageCodeVisible = true
  },
  hideImageCode (state) {
    state.imageCodeVisible = false
  },
  setCaptchaInfo (state, value) {
    state.captchaInfo = value
  },
  setMobileReal (state, value) {
    state.mobileReal = value
  },
  setMobileShow (state, value) {
    state.mobileShow = value
  },
  changeBindStatus (state, status) {
    state.bindPhoneStatus = status
  },
  setCheckKey (state, key) {
    state.checkKey = key
  },
  setToUrl (state, url) {
    state.toUrl = url
  },
  showSMSCode (state) {
    state.SMSCodeVisible = true
  },
  hideSMSCode (state) {
    state.SMSCodeVisible = false
  },
  setImageCodeURL (state, value) {
    state.imageCodeURL = value
  },
  setImageCodeToken (state, value) {
    state.imageCodeToken = value
  }
}
export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/index.js